import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import Constancia from "./Constancias/Constancia";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerTodasConstanciasRegistro,
  obtenerTodasConstanciasExtraccion,
  obtenerTodasConstanciasGuiasUnicas,
} from "../../../redux/DucksUsuarioAgricola/ConstanciaDucks";
import ConstanciaGuia from "./Constancias/ConstaciaGuia";

function PanelConstancia(props) {

  const dispatch = useDispatch();
  const [dataRegistro, setDataRegistro] = React.useState([]);
  const [dataNuevaGuia, setDataNuevaGuia] = React.useState([]);

  //let dataRegistro = useSelector((store) => store.ConstanciasApi.data.dataRegistro.data);
  let dataExtraccion = useSelector((store) => store.ConstanciasApi.data.dataExtraccion.data);
  //let dataNuevaGuia = useSelector((store) => store.ConstanciasApi.data.dataGuiaUnica?.data);
  const [value, setValue] = React.useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(async () => {
    /*switch (value) {
      case 0:*/
    if (props?.location?.state == null) {
      let constancia = await dispatch(obtenerTodasConstanciasRegistro())
      await setDataRegistro(constancia?.payload?.data?.data)
      setValue(0)
    }
    let constancia = await dispatch(obtenerTodasConstanciasRegistro())
    setDataRegistro(constancia?.payload?.data?.data)
    /*
    break;
  case 1:*/
    let guias = await dispatch(obtenerTodasConstanciasGuiasUnicas())
    setDataNuevaGuia(guias?.payload?.data?.data)
    /*
    break;
  case 2:
    await dispatch(obtenerTodasConstanciasExtraccion());
    break;
  default:
    await dispatch(obtenerTodasConstanciasRegistro());
    break;
}*/
  }, []);


  const dataTableHead = ["Numero de Paraje", "Número de Cliente", "Nombre", "Constancia"/*, "OPCIONES"*/];

  return (
    <Fragment>
      <br />
      <div className="container">
        <div className="p-2 rounded ms-5">
          <Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange} centered>
              <Tab label="Constancia de Registro" />
              <Tab label="Guias de Extracción" />
              {/* <Tab label="Nuevas Guias" /> */}
            </Tabs>
          </Box>

          <div className="row">
            {value === 0 && (
              <Constancia
                dataValues={dataRegistro ? dataRegistro : []}
                dataTableHead={dataTableHead}
              >
              </Constancia>
            )}

            {value === 2 && (
              <Constancia
                dataValues={dataExtraccion ? dataExtraccion : []}
                dataTableHead={dataTableHead}
              ></Constancia>
            )}

            {value === 1 && (
              <ConstanciaGuia
                dataValues={dataNuevaGuia ? dataNuevaGuia : []}
                dataTableHead={dataTableHead}
              ></ConstanciaGuia>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default withRouter(PanelConstancia);
